import {
  Modal,
  Box,
  Button,
  Typography,
  Fade,
  Zoom,
  Backdrop,
} from "@mui/material"
import deleteIcon from "../../icons/harmonization/deleteIcon.svg"
const DeleteModal = ({
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  handleDeleteMapping,
}: any) => {
  return (
    <Modal
      open={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isDeleteModalOpen}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            px: 10,
            py: 8,
            borderRadius: 3,
            gap: 1,
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Zoom in={isDeleteModalOpen}>
            <img
              style={{ height: "3.5rem", margin: "auto" }}
              src={deleteIcon}
              alt="delete"
            />
          </Zoom>

          <Typography
            variant="h6"
            id="modal-modal-title"
            sx={{
              textAlign: "center",
              fontSize: "16px",
              color: "customColors.textGrey1",
            }}
          >
            Are you sure you want to delete?
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              mt: 0.5,
              gap: 1,
            }}
          >
            <Button
              onClick={handleDeleteMapping}
              variant="contained"
              sx={{ color: "#fff", textTransform: "none" }}
            >
              Yes
            </Button>
            <Button
              onClick={() => setIsDeleteModalOpen(false)}
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  )
}

export default DeleteModal
